module.exports = __webpack_public_path__ + "static/img/伙伴客户-京东健康.73a7a124.png";